import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ph-tab',
  templateUrl: './ph-tab.component.html',
  styleUrls: ['./ph-tab.component.scss'],
})
export class PhTabComponent {
  @Input() title: string;
  @Input() number: string | number;
  @Input() active: boolean = false;
  @Input() name: string = null;
  @Input() hideTab: boolean = false;
  @Output() changeTab: EventEmitter<any> = new EventEmitter();

  constructor() {}
}
